import {dateAndTime} from "../date/formatters";

export const CANCELLATION_POLICIES = {
    NOT_REFUNDABLE: 'not_refundable',
    TIME_RESTRICTED_REFUNDABLE: 'time_restricted_refundable',
    TOTALLY_REFUNDABLE: 'totally_refundable',
    NONE: 'none',
}

export const CANCELLATION_POLICIES_REGISTRY = [
    {
        value: CANCELLATION_POLICIES.NOT_REFUNDABLE,
        label: 'Non rimborsabile',
        getDescription: () => 'In caso di cancellazione, non verrà effettuato alcun rimborso.',
    },
    {
        value: CANCELLATION_POLICIES.TIME_RESTRICTED_REFUNDABLE,
        label: 'Rimborsabile con restrizioni temporali',
        getDescription: ({refundableUntil}) => 'In caso di cancellazione, il rimborso sarà possibile solo se effettuata entro la data ' + (refundableUntil ? dateAndTime(refundableUntil) : 'gg/mm/aaaa hh:mm') + '. Dopo tale data, non verrà effettuato alcun rimborso.',
    },
    {
        value: CANCELLATION_POLICIES.TOTALLY_REFUNDABLE,
        label: 'Completamente rimborsabile',
        getDescription: () => 'In caso di cancellazione, verrà effettuato un rimborso completo dell\'importo pagato.',
    },
    {
        value: CANCELLATION_POLICIES.NONE,
        label: 'Non specificata',
        getDescription: () => 'Nessuna politica di cancellazione specificata.',
    }
];

export const TOURIST_TAX_POLICIES = {
    INCLUDED: 'included',
    EXCLUDED: 'excluded',
    NONE: 'none',
}


export const TOURIST_TAX_POLICIES_REGISTRY = [
    {
        value: TOURIST_TAX_POLICIES.INCLUDED,
        label: 'Inclusa nel prezzo',
        getDescription: () => 'La tassa di soggiorno è inclusa nel prezzo totale della prenotazione.',
    },
    {
        value: TOURIST_TAX_POLICIES.EXCLUDED,
        label: 'Esclusa dal prezzo',
        getDescription: ({touristTaxUnitPrice}) => 'La tassa di soggiorno non è inclusa nel prezzo totale della prenotazione e sarà calcolata separatamente. Il costo della tassa di soggiorno a persona a notte è: ' + (touristTaxUnitPrice ? touristTaxUnitPrice.toFixed(2) + ' €' : 'non specificato'),
    },
    {
        value: TOURIST_TAX_POLICIES.NONE,
        label: 'Non specificata',
        getDescription: () => 'Nessuna politica di tassa di soggiorno specificata.',
    }
];